import { Theme } from "@mui/material";

export const SignRequestStyles = (theme: Theme) => ({
  responsiveIcon: {
    [theme.breakpoints.up("lg")]: {
      width: "20px",
    },
    [theme.breakpoints.down("lg")]: {
      width: "14px",
    },
  },
  summary: {
    "&:hover": {
      background: theme.palette.action.hover,
      borderRadius: "10px 10px 0px 0px",
    },
    "& .Mui-expanded": {
      "& svg": {
        transform: "rotate(-90deg) !important",
      },
    },
  },
  inputLabel: {
    color: "primary.main",
    fontSize: "14px",
    flexShrink: 0,
    fontWeight: 600,
  },
  dropDownStyle: {
    backgroundColor: theme.palette.background.paper,
    height: "47px",
    padding: "2px",
    width: "100%",
    borderRadius: "12px",
    fontSize: "16px",
  },
  chip: {
    width: "fit-content",
    margin: "1px 2px",
    // Transparent so the shared documentCardGradient (peach → lavender) shows
    // through, matching the mobile upload chip which sits on the same gradient.
    backgroundColor: "transparent !important",
    color: `${theme.palette.mobile.base[500]} !important`,
    "& .MuiChip-deleteIcon": {
      color: `${theme.palette.mobile.grey[400]} !important`,
      "&:hover": { color: `${theme.palette.mobile.grey[400]} !important` },
    },
    "& .MuiChip-label": {
      zIndex: 3,
      color: `${theme.palette.mobile.base[500]} !important`,
    },
    "& .MuiChip-avatar": {
      width: "15px",
      height: "15px",
      color: `${theme.palette.mobile.base[500]} !important`,
    },
    borderRadius: "8px",
  },
});
